import { FC, useState } from 'react'
import { Box, useTheme } from '@mui/material'
import { Modal } from 'components/Modal'
import { PasswordInput } from 'components/PasswordInput'
import { ItemDetails } from 'components'
import { useTranslation } from 'react-i18next'

export interface SetPasswordProps {
    open?: any
    onClose?: any
    onCancel?: any
}

export const SetPassword: FC<SetPasswordProps> = (props) => {
    const { open, onClose, onCancel } = props
    const [value] = useState('')
    const [confirmationValue] = useState('')
    const theme = useTheme()
    const { t } = useTranslation()

    const footerContent = (
        <Box
            display="flex"
            justifyContent="space-between"
            width="100%"
            padding="24px 32px"
        >
            <Box minWidth="88px">
                <ItemDetails.ActionButton
                    fontColor="#ffffff"
                    bgColor={theme?.palette?.primary?.main}
                    width="100%"
                >
                    {t('OK')}
                </ItemDetails.ActionButton>
            </Box>

            <Box minWidth="130px">
                <ItemDetails.ActionButton
                    fontColor="#ffffff"
                    bgColor={'#aab0b4'}
                    width="100%"
                    onClick={onCancel}
                >
                    {t('Cancel')}
                </ItemDetails.ActionButton>
            </Box>
        </Box>
    )

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={t('EnterTheNewMasterPasswordToEncrypt/DecryptYourSecrets')}
            footerContent={footerContent}
        >
            <Box>
                In order to access priviledged resources you first have to set
                you a Master Password helpful text will go here to help users
                make better sense of this operation.
            </Box>

            <Box marginY="24px">
                <PasswordInput
                    value={value}
                    placeholder={t('NewMasterPassword')}
                />
            </Box>

            <Box marginY="24px">
                <PasswordInput
                    value={confirmationValue}
                    placeholder={t('ConfirmPassword')}
                />
            </Box>
        </Modal>
    )
}
